
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24px","height":"24px","viewBox":"0 0 24 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Group')]),_c('g',{attrs:{"id":"Group"}},[_c('path',{attrs:{"d":"M17.169922,2.9433594 C16.762814,2.9433594 16.354616,3.0965969 16.046875,3.4042969 L4.421875,15.029297 L4.388672,15.169922 L3.0566407,20.9433594 L8.9707032,19.578125 L20.5957031,7.953125 C21.2109781,7.337625 21.2112331,6.3243844 20.5957031,5.7089844 L18.291016,3.4042969 C17.983323,3.0965969 17.57703,2.9433594 17.169922,2.9433594 Z M17.169922,3.9335938 C17.318499,3.9335938 17.466138,3.9934278 17.583984,4.1113281 L19.888672,6.4179688 C20.12453,6.6537687 20.124525,7.0101938 19.888672,7.2460938 L17.933594,9.2011719 L14.798828,6.0683594 L16.753906,4.1113281 C16.871829,3.9933781 17.021345,3.9335938 17.169922,3.9335938 Z M14.091797,6.7753906 L17.226562,9.9101562 L8.71875,18.416016 L5.5839844,15.283203 L14.091797,6.7753906 Z M5.1621094,16.275391 L7.7265625,18.837891 L4.3925781,19.609375 L5.1621094,16.275391 Z","id":"Shape","stroke":"currentColor","stroke-width":"0.6","fill":"currentColor","fill-rule":"nonzero"}})])])
          )
        }
      }
    